<template>
  <div class="row">
    <div v-if="showFilters" class="col-24 col-lg-5">
      <FormInput
        :value="keyword"
        @input="handleInput"
        :placeholder="t.search_placeholder"
        name="vendorSearch"
        type="search"
      />
      <div class="form-group">
        <div class="form-check mr-2">
          <input
            id="deliveryCheckbox"
            :checked="filterDelivery"
            @click="toggleDelivery"
            class="form-check-input"
            type="checkbox"
          />
          <label class="form-check-label" for="deliveryCheckbox">{{ t.delivery }}</label>
        </div>
        <div class="form-check">
          <input
            id="selfCollectCheckbox"
            :checked="filterSelfCollect"
            @click="toggleSelfCollect"
            class="form-check-input"
            type="checkbox"
          />
          <label class="form-check-label" for="selfCollectCheckbox">{{ t.self_collect }}</label>
        </div>
      </div>
    </div>
    <div class="col-24 col-lg-18 flex-grow-1">
      <div v-if="filteredVendors.length > 0">
        <div v-for="(vendorGroup, i) in vendorGroups" :key="i">
          <p class="h2 mb-2">{{ vendorGroup[0].name[0].toUpperCase() }}</p>
          <div class="row mb-4">
            <div v-for="(vendor, j) in vendorGroup" :key="j" class="col-sm-12 mb-2">
              <VendorTile
                :badges="vendor.badges"
                :categories="vendor.categories"
                :address="vendor.address"
                :description="vendor.description"
                :image="vendor.image"
                :name="vendor.name"
                :product-link="
                  vendor.product_link && { url: vendor.product_link, text: t.product_link }
                "
                :link="vendor.url && { url: vendor.url, text: t.profile_link }"
              >
              </VendorTile>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        {{ t.no_vendors_found }}
      </div>
    </div>
  </div>
</template>

<script>
import VendorTile from "./VendorTile.vue";
import FormInput from "./FormInput.vue";

export default {
  name: "VendorList",
  components: {
    VendorTile,
    FormInput,
  },
  props: {
    vendors: {
      type: Array,
      required: true,
    },
    t: {
      type: Object,
      required: true,
    },
    showFilters: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      keyword: "",
      filterDelivery: false,
      filterSelfCollect: false,
    };
  },
  computed: {
    filteredVendors() {
      return this.vendors
        .filter(vendor => vendor.name.toLowerCase().includes(this.keyword.toLowerCase()))
        .filter(vendor =>
          this.filterDelivery ? vendor.badges.some(badge => badge.key === "delivery") : true
        )
        .filter(vendor =>
          this.filterSelfCollect ? vendor.badges.some(badge => badge.key === "self_collect") : true
        );
    },
    vendorGroups() {
      const groups = {};

      for (const vendor of this.filteredVendors) {
        const letter = vendor.name[0].toUpperCase();
        const group = groups[letter] || [];
        group.push(vendor);
        groups[letter] = group;
      }

      for (const key in groups) {
        groups[key] = groups[key].sort((a, b) => b.badges.length - a.badges.length);
      }

      return Object.keys(groups)
        .sort()
        .reduce(
          (acc, key) => ({
            ...acc,
            [key]: groups[key],
          }),
          {}
        );
    },
  },
  methods: {
    handleInput(value) {
      this.keyword = value;
    },
    toggleDelivery() {
      this.filterDelivery = !this.filterDelivery;
    },
    toggleSelfCollect() {
      this.filterSelfCollect = !this.filterSelfCollect;
    },
  },
};
</script>
